import type { FormattedFeedProductType } from '@/types'

import { ColumnsService } from './ColumnsService'
import { ExpandedRowsService } from './ExpandedRowsService'
import type { PaginationCallbacks, SearchParams } from './feedTypes'
import { PaginationService } from './PaginationService'

class FeedService {
  private static instance: FeedService | null = null

  private expandedRowsService: ExpandedRowsService
  private paginationService: PaginationService
  private columnsService: ColumnsService

  private constructor() {
    this.expandedRowsService = new ExpandedRowsService()
    this.paginationService = new PaginationService()
    this.columnsService = new ColumnsService()
  }

  static getInstance(): FeedService {
    if (!FeedService.instance) {
      FeedService.instance = new FeedService()
    }
    return FeedService.instance
  }

  initializeFeed(tokenRoles: readonly string[]): string[] | null | undefined {
    return this.columnsService.getColumnsKeys(tokenRoles)
  }

  calculateExpandedRows(
    products: FormattedFeedProductType[],
    productInfoToCartPresence: Record<string, number>
  ): string[] {
    return this.expandedRowsService.calculate(
      products,
      productInfoToCartPresence
    )
  }

  async handlePagination(
    page: number,
    pageSize: number,
    searchParams: SearchParams,
    callbacks: PaginationCallbacks
  ): Promise<void> {
    await this.paginationService.handlePageChange(
      page,
      pageSize,
      searchParams,
      callbacks
    )
  }

  shouldLockScroll(productsLoading: boolean): boolean {
    return productsLoading
  }

  resetPaginationOnSearchChange(): {
    current: number
    pageSize: number
    total: number
  } {
    return this.paginationService.getDefaultPagination()
  }
}

export const feedService = FeedService.getInstance()
